module.exports = __webpack_public_path__ + "static/media/image_3_People 1.a565e409.png";